import React from "react";
import {Link} from "react-router-dom";

interface CountrySelectionProps {
  countryName: string;
  countryFlagPath: string;
  countryPath: string;
}

const CountrySelection: React.FC<CountrySelectionProps> = ({countryName, countryFlagPath, countryPath}) => {

  return (
    <Link to={"/" + countryPath} preventScrollReset={false}>
      <div className="flex flex-col items-center pt-7 pb-7 bg-white rounded-3xl">
        <img className="rounded-2xl mb-5" src={countryFlagPath} alt="Germany"/>
        <p className="px-1 text-center">{countryName}</p>
      </div>
    </Link>
  );
}

export default CountrySelection;